"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Problem = void 0;
const constants_1 = require("./constants");
class Problem {
    constructor(question) {
        this.similarProblems = [];
        const { questionId, questionFrontendId, title, titleSlug, content, isPaidOnly, likes, dislikes, isLiked, similarQuestions, exampleTestcases, companyTagStats, stats, hints, sampleTestCase, acRate, difficulty, freqBar, isFavor, status, topicTags, hasSolution, hasVideoSolution, } = question;
        this.questionId = questionId;
        this.questionFrontendId = questionFrontendId;
        this.title = title;
        this.titleSlug = titleSlug;
        this.content = content;
        this.isPaidOnly = isPaidOnly;
        this.likes = likes;
        this.dislikes = dislikes;
        this.isLiked = isLiked;
        this.similarQuestions = similarQuestions;
        this.exampleTestcases = exampleTestcases;
        this.companyTagStats = companyTagStats;
        this.stats = stats;
        this.hints = hints;
        this.sampleTestCase = sampleTestCase;
        this.acRate = acRate;
        this.difficulty = difficulty;
        this.freqBar = freqBar;
        this.isFavor = isFavor;
        this.status = status;
        this.topicTags = topicTags;
        this.hasSolution = hasSolution;
        this.hasVideoSolution = hasVideoSolution;
        this.url = `${constants_1.Constants.ENDPOINT}/problems/${titleSlug}`;
    }
}
exports.Problem = Problem;
